import { motion } from 'framer-motion';

import styles from './index.module.scss';

export const Loader = () => {
	return (
		<div className={styles.loaderContainer}>
			{[0, 1, 2].map(dot => (
				<motion.div
					key={dot}
					className={styles.loaderDot}
					animate={{ opacity: [0.2, 0.35, 0.5, 0.35, 0.2] }}
					transition={{
						repeat: Infinity,
						duration: 1,
						ease: 'easeInOut',
						delay: dot * 0.3
					}}
				/>
			))}
		</div>
	);
};
